import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from "../../../utilities/TableUtil";
import { normalColumn } from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";

export default function P115List_3({ dataTable }) {
    // const [globalFilter, setGlobalFilter] = useState(null);
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });
    return (
        <div className="datatable-responsive-modify">
            <div className="card">
                <DataTable
                    // ref={(el) => dt = el}
                    value={dataTable}
                    dataKey="id"
                    paginator
                    first={pageConf.first}
                    rows={pageConf.rows} 
                    onPage={(e)=>onPageChange(e,setPageConf)}
                    rowsPerPageOptions={rowsPerPageOptions()}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    // globalFilter={globalFilter}
                    emptyMessage="ไม่พบข้อมูล"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    selectionMode="single"
                >
                    <Column field="routeNo" header="เส้นทางที่" body={(e) => normalColumn(e, "routeNo", "เส้นทางที่")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="routeName" header="ชื่อเส้นทาง" body={(e) => normalColumn(e, "routeName", "ชื่อเส้นทาง")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="totalLength" header="ความยาวรวม(เมตร)" body={(e) => normalColumn(e, "totalLength", "ความยาวรวม(เมตร)")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="totalAmount" header="มูลค่ารวม" body={(e) => normalColumn(e, "totalAmount", "มูลค่ารวม")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column sortable field="withdrawAmount" header="เบิกแล้ว(บาท)" body={(e) => normalColumn(e, "withdrawAmount", "เบิกแล้ว(บาท)")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="withdrawPercent" header="%" body={(e) => normalColumn(e, "withdrawPercent", "%")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                </DataTable>
            </div>
        </div>
    );
}
